import { render, staticRenderFns } from "./autocomplete-clinics-situations.vue?vue&type=template&id=cb45c270&scoped=true&lang=pug&"
import script from "./autocomplete-clinics-situations.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-clinics-situations.vue?vue&type=script&lang=ts&"
import style0 from "./autocomplete-clinics-situations.vue?vue&type=style&index=0&id=cb45c270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45c270",
  null
  
)

export default component.exports